// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"fde4c9b4","703":"33b059d7"}[chunkId] + ".chunk.js";
};